import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Globe } from 'lucide-react';

function formatNumber(value) {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(0)}K`;
  return value.toString();
}

export default function DigitalPresence({ digital }) {
  if (!digital) return null;
  
  return (
    <Card className="bg-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Globe className="w-4 h-4" />
          Digital Presence
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-3 rounded bg-muted/30">
            <p className="text-sm text-muted-foreground">Instagram</p>
            <p className="text-xl font-bold">{formatNumber(digital.instagram?.followers || 0)}</p>
          </div>
          <div className="p-3 rounded bg-muted/30">
            <p className="text-sm text-muted-foreground">Twitter/X</p>
            <p className="text-xl font-bold">{formatNumber(digital.twitter?.followers || 0)}</p>
          </div>
          <div className="p-3 rounded bg-muted/30">
            <p className="text-sm text-muted-foreground">TikTok</p>
            <p className="text-xl font-bold">{formatNumber(digital.tiktok?.followers || 0)}</p>
          </div>
          <div className="p-3 rounded bg-muted/30">
            <p className="text-sm text-muted-foreground">YouTube</p>
            <p className="text-xl font-bold">{formatNumber(digital.youtube?.subscribers || 0)}</p>
          </div>
        </div>
        <div className="mt-4 p-3 rounded bg-primary/10 text-center">
          <p className="text-sm text-muted-foreground">Total Reach</p>
          <p className="text-2xl font-bold text-primary">{formatNumber(digital.total_social_reach || 0)}</p>
        </div>
      </CardContent>
    </Card>
  );
}
